export default "__VITE_ASSET__CmQJbdxh__"